import { render, staticRenderFns } from "./AccountListSetPrivilege.vue?vue&type=template&id=47ef63f1"
import script from "./AccountListSetPrivilege.vue?vue&type=script&lang=js"
export * from "./AccountListSetPrivilege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports